import React, { useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import "./experts.css";
import expertData from "../data/SAP/expert_popup.json";
import axios from "axios";
import { ExpertsImageParams } from "../imagesData/imagesData.js";
import { Card, CardContent, Typography, Avatar, Box } from "@mui/material";
import { atci_lkm_sap_mail, saraswathi_mail } from "../utils/mailIds.js";
import baseURL from "../utils/Constants.js";

const ProfileCard = ({ name, eid, role, imageUrl }) => {
  return (
    <Card
      sx={{
        textAlign: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Avatar
          alt={name}
          src={imageUrl}
          sx={{
            width: 80,
            height: 80,
            border: "1px solid black",
          }}
        />
      </Box>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {name}
        </Typography>
        <Typography variant="h6" gutterBottom>
          {`${eid}@accenture.com`}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {role}
        </Typography>
      </CardContent>
    </Card>
  );
};

const Experts = () => {
  const [imageUrls, setImageUrls] = useState({});
  const query = `params=${encodeURIComponent(
    JSON.stringify(ExpertsImageParams)
  )}`;

  useEffect(() => {
    const fetchImageUrls = async () => {
      try {
        const response = await axios.get(`${baseURL}/images?${query}`);
        setImageUrls(response.data);
      } catch (error) {
        console.error("Error fetching image URLs:", error);
      }
    };

    fetchImageUrls();
  }, []);

  const [view, setView] = useState(false);
  const [viewMore, setViewMore] = useState(false);
  const [modalOpen, setModelOpen] = useState("");
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const [expert, setExpert] = useState(null);

  const botClickFun = () => {
    document.getElementById("cai-webclient-builtin-button").click();
  };
  const handleOpenModal = () => {
    setShow(true);
  };
  const handleCloseModal = () => {
    setShow(false);
  };
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setView(false);
    setViewMore(false);
    setExpert(null);
  };

  return (
    <>
      <div id="main_container">
        <div className="testimonial_banner1">
          <img src="/images/SAP/sap_experts.png" alt="Expert-Banner" />
        </div>
        <div className="section_container">
          <p className="infoPara">
            Meet the minds behind ATCI’s intensive, innovative, fit-for-market
            SAP learning programs, enabling Accenture to lead in the marketplace
            and deliver on the promise of client excellence.
          </p>
        </div>
        <div className="experts_container">
          <div className="topRowContent">
            {expertData?.Leadership.map((expert, index) => (
              <div
                style={{
                  display: "inline-block",
                  boxSizing: "border-box",
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleOpen();
                  setExpert(expert);
                }}
              >
                <div className="profile-card">
                  <div className="header-shape">
                    <img
                      src={imageUrls?.imageUrl?.[`imgLS${index}`]}
                      // src="/images/Experts/PraveenRajaram.png"
                      alt="Profile"
                      className="profile-img"
                    />
                    <div className="translateup">
                      <h2 className="name">{expert.name}</h2>
                      <p className="email">{`${expert.EID}@accenture.com`}</p>
                      <p className="title">{expert.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
            <div className="leadsRowContent">
            {expertData?.Lead.map((expert, index) => (
              <div
                style={{
                  display: "inline-block",
                  boxSizing: "border-box",
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleOpen();
                  setExpert(expert);
                }}
              >
                <div className="profile-card">
                  <div className="header-shape">
                    <img
                      src={imageUrls?.imageUrl?.[`imgL${index}`]}
                      // src="/images/Experts/PraveenRajaram.png" alt="Expert-Banner"
                      alt="Profile"
                      className="profile-img"
                    />
                    <div className="translateup">
                      <h2 className="name">{expert.name}</h2>
                      <p className="email">{`${expert.EID}@accenture.com`}</p>
                      <p className="title">{expert.role}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            </div>
          <div className="leadsRowContent">
            {/* traversing Lead Array */}

            {/* traversing SME array   */}
            {expertData?.SME.map((expert, index) => (
              <div
                style={{
                  display: "inline-block",
                  boxSizing: "border-box",
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleOpen();
                  setExpert(expert);
                }}
              >
                <div className="profile-card">
                  <div className="header-shape">
                    <img
                      src={imageUrls?.imageUrl?.[`imgSME${index}`]}
                      // src="/images/Experts/PraveenRajaram.png" alt="Expert-Banner"
                      alt="Profile"
                      className="profile-img"
                    />
                    <div className="translateup">
                      <h2 className="name">{expert.name}</h2>
                      <p className="email">{`${expert.EID}@accenture.com`}</p>
                      <p className="title">
                        <strong>Focus Areas: </strong>
                        {expert.role}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <Modal
          hideBackdrop
          open={open}
          onClose={handleClose}
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          className="expert_main-model"
        >
          <div className="model_experts">
            <div className="model_heading_experts">
              
                <p className="model-name">{expert?.name}</p>
              
              <span className="experts_close_btn_model" onClick={handleClose}>
                <img
                  src="/images/Experts/close_img.png"
                  alt="icon"
                  className="experts_close_img"
                />
              </span>
            </div>
            <img
              src="/images/Experts/top line.png"
              alt="Experts-img"
              className="topline-img"
            />
            <div className="header_experts">
              <img
                src="/images/Experts/Skill sets.png"
                alt="icon"
                className="skill_set_img"
              />
              <p className="para_experts">Skill Sets</p>
            </div>

            <div className="skill_sets_data">
              {expert?.skillSets.slice(0, 8).map((item) => {
                return (
                  <div className="skill_sets_content">
                    <img
                      src="/images/Experts/Bulletpoint.png"
                      alt="icon"
                      className="skill_bullet_point_img"
                    />
                    <p className="skill_bullet_point_text">{item}</p>
                  </div>
                );
              })}
              {view &&
                expert?.skillSets
                  .slice(8, expert?.skillSets.length)
                  .map((item) => {
                    return (
                      <div className="skill_sets_content">
                        <img
                          src="/images/Experts/Bulletpoint.png"
                          alt="icon"
                          className="skill_bullet_point_img"
                        />
                        <p className="skill_bullet_point_text">{item}</p>
                      </div>
                    );
                  })}
            </div>
            {8 < expert?.skillSets.length && (
              <div
                className="expert_viewmore_sp"
                onClick={() => setView(!view)}
              >
                {view ? "View less" : "View more"}
              </div>
            )}
            <img
              src="/images/Experts/Middle line.png"
              alt="Experts-img"
              className="topline-img"
            />
            <div className="header_experts">
              <img
                src="/images/Experts/Certification Acquired.png"
                alt="icon"
                className="skill_set_img"
              />
              <p className="para_experts">Certification Acquired</p>
            </div>
            <div className="skill_sets_data">
              {expert?.certificationAcquired.slice(0, 6).map((item) => {
                return (
                  <div className="skill_sets_content">
                    <img
                      src="/images/Experts/Bulletpoint.png"
                      alt="icon"
                      className="skill_bullet_point_img"
                    />
                    <p className="skill_bullet_point_text1">{item}</p>
                  </div>
                );
              })}
              {viewMore &&
                expert?.certificationAcquired
                  .slice(6, expert?.certificationAcquired.length)
                  .map((item) => {
                    return (
                      <div className="skill_sets_content">
                        <img
                          src="/images/Experts/Bulletpoint.png"
                          alt="icon"
                          className="skill_bullet_point_img"
                        />
                        <p className="skill_bullet_point_text1">{item}</p>
                      </div>
                    );
                  })}
            </div>
            {6 < expert?.certificationAcquired.length && (
              <div
                className="expert_viewmore_sp"
                onClick={() => setViewMore(!viewMore)}
              >
                {viewMore ? "View less" : "View more"}
              </div>
            )}
          </div>
        </Modal>

        <div className="socialMediaWrap">
          <button className="iconBtn icon6">
            <a
              href="https://atci.lkm.eitacademy.accenture.com/SAPAcademy/sap-calendar/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/SAP/sap_calendar.png"}
                alt="oracle-icon"
              />
              <span>SAP Calendar</span>
            </a>
          </button>
          <button className="iconBtn icon5">
            <a
              href="https://atci.lkm.accenture.com/LKM-eCatalog/SAP-Flipbook"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/SAP/catalogue_icon.png"}
                alt="ecatalogs-icon"
              />
              <span>SAP eCatalog</span>
            </a>
          </button>
          <button className="iconBtn icon4" onClick={botClickFun}>
            <img
              src={
                process.env.PUBLIC_URL +
                "/images/SocialLearning/noun-chatbot-4562760.svg"
              }
              alt="oracle-icon"
            />
            <span>SAP Bot</span>
          </button>
          <button onClick={handleOpenModal} className="iconBtn icon1">
            <img
              src={
                process.env.PUBLIC_URL + "/images/SocialLearning/present.svg"
              }
              alt="oracle-icon"
            />
            <span>Request for Training</span>
          </button>
          <Modal
            open={show}
            onClose={handleCloseModal}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
          >
            <div className="model-container">
              <span
                className="close_btn_model_reqtraining"
                onClick={handleCloseModal}
              >
                X
              </span>
              <h4>Request For Training</h4>
              <div className="model_heading_reqtraining">
                <p className="model_name_reqtraining">
                  <a
                    href="https://lkmportal.atci.accenture.com/LMS/Need/RaiseTrainingRequest"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Link to raise training request
                  </a>
                </p>
                <div className="modal_content_reqtraining">
                  For further queries please get in touch with <br />
                </div>
                <p className="model_contact_reqtraining">
                  <a
                    href={`mailto:${saraswathi_mail}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Swaminathan, Saraswathi.
                  </a>
                </p>
              </div>
            </div>
          </Modal>
          <button className="iconBtn icon2">
            <a
              href="https://web.yammer.com/main/org/accenture.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiI1NzgyMjY5OTUyMCJ9"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={
                  process.env.PUBLIC_URL + "/images/SocialLearning/Yammer1.png"
                }
                alt="oracle-icon"
              />
              <span>Connect with Community</span>
            </a>
          </button>
          <button className="iconBtn icon3">
            <a
              href={`mailto:${atci_lkm_sap_mail}`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={process.env.PUBLIC_URL + "/images/SocialLearning/mail.svg"}
                alt="oracle-icon"
              />
              <span>Contact Us</span>
            </a>
          </button>
        </div>
      </div>
    </>
  );
};

export default Experts;
